/**
 * Price Calculator Module
 * Handles all price calculations for custom product fields
 */
export class PriceCalculator {
  constructor(options) {
    this.config = options
  }

  toOre(price) {
    return Math.round(price * 100) / 100
  }

  // Whole krona, halves rounded up (19 818.75 -> 19 819). Same as BusinessPrice::roundUnit() in PHP:
  // integer öre arithmetic, everything is rounded (also amounts below 1 kr).
  wholeKrona(price) {
    return Math.floor((Math.round(price * 100) + 50) / 100)
  }

  hasVariation(variationId) {
    return (
      !!variationId && variationId !== '0' && this.config.variationPrices[variationId] !== undefined
    )
  }

  getVariationPrice(variationId) {
    return parseFloat(this.config.variationPrices[variationId]) || 0
  }

  getUtforandePrice(selectedValue) {
    if (this.config.utforandeData && this.config.utforandeData[selectedValue]) {
      return parseFloat(this.config.utforandeData[selectedValue].price) || 0
    }
    return 0
  }

  calculateTotalPrice(options) {
    const { variationId, selectedUtforande, bredd, hojd, totalHeight, opening, overljus } = options

    let totalPrice = this.getVariationPrice(variationId) + this.getUtforandePrice(selectedUtforande)

    if (bredd > 0 || hojd > 0 || totalHeight > 0 || opening > 0) {
      if (this.config.calculationType === 'total_height' && bredd > 0) {
        totalPrice += this.config.breddPrice * bredd + this.config.heightPrice * hojd
      } else if (this.config.calculationType === 'opening_height' && bredd > 0) {
        totalPrice +=
          this.config.breddPrice * bredd +
          this.config.transomPrice * overljus +
          this.config.heightPrice * hojd
      } else if (this.config.calculationType === 'opening_height_split' && bredd > 0) {
        totalPrice += this.config.breddPrice * bredd + this.config.totalHeightPrice * totalHeight
      } else if (this.config.calculationType === 'fast_racke' && bredd > 0) {
        totalPrice += this.config.breddPrice * bredd + this.config.heightPrice * hojd
      }
    }

    // Calculate original price with tax as a whole krona (same as the cart)
    const originalPrice = this.wholeKrona(totalPrice * this.config.taxRate)

    // Calculate discounted price if discount is available
    let discountedPrice = null
    if (typeof window.businessDiscount !== 'undefined' && window.businessDiscount.hasDiscount) {
      const discount = window.businessDiscount.discount
      const discountAmount = totalPrice * (discount / 100)
      // Same as BusinessPrice::discountedPrice() in PHP: the discounted price is rounded up before VAT
      discountedPrice = this.wholeKrona(
        Math.ceil(totalPrice - discountAmount) * this.config.taxRate
      )
    }

    return {
      originalPrice: originalPrice,
      discountedPrice: discountedPrice,
      hasDiscount:
        (typeof window.businessDiscount !== 'undefined' && window.businessDiscount.hasDiscount) ||
        false
    }
  }
}
